import { useCallback, useMemo } from 'react';
import cn from 'bem-cn';

import { ScreenSize, useGetScreenSize } from '../../../../hooks';
import { List, Stack } from '../../../UI';

import { ChallengePrize, ChallengePrizeType } from './ChallengePrize';
import { getChallengePrizes } from './ChallengePrizes.constants';
import { ChallengePrizesProps } from './ChallengePrizes.types';
import './ChallengePrizes.scss';

const b = cn('challenge-prizes');

const extractTagKey = (_: ChallengePrizeType, index: number) => `prize-${index}`;

export const ChallengePrizes = (props: ChallengePrizesProps) => {
    const { challengeTitle } = props;

    const screenSize = useGetScreenSize();
    const prizes = useMemo(() => getChallengePrizes(challengeTitle), [challengeTitle]);

    const isTouch = screenSize === ScreenSize.Mobile || screenSize === ScreenSize.Tablet;
    const isUnfilled = isTouch ? prizes.length % 2 === 1 : prizes.length % 3 === 1;

    const renderPrizeItem = useCallback(
        (item: ChallengePrizeType, index: number) => {
            return <ChallengePrize prize={item} last={isUnfilled && index === prizes.length - 1} />;
        },
        [isUnfilled, prizes.length],
    );

    return (
        <Stack spacing={16} className={b()}>
            <h2 className={b('title')}>Призы для победителей</h2>
            <List
                direction="row"
                className={b('list', { unfilled: isUnfilled })}
                items={prizes}
                renderItem={renderPrizeItem}
                keyExtractor={extractTagKey}
            />
        </Stack>
    );
};
